module.exports = __webpack_public_path__ + "static/img/course_img3.f9d4b2fd.jpg";